// Native EventSource uses an authenticated, one-use 20s ticket, never the long-lived JWT.
export function startMessageStream(api, { onChange, onStatus, isCurrent = () => true }, Source = window.EventSource) {
  if (!Source || !api.config || !api.streamTicket) return { stop() {} }
  let stopped = false, generation = 0, source, abort, timer, readyTimer, failures = 0
  const close = () => { source?.close(); source = null; abort?.abort(); clearTimeout(timer); clearTimeout(readyTimer) }
  const schedule = delay => { clearTimeout(timer); if (!stopped) timer = setTimeout(connect, delay) }
  async function connect() {
    close()
    if (stopped || !isCurrent() || navigator.onLine === false) return
    const g = ++generation
    abort = new AbortController()
    const current = () => !stopped && g === generation && isCurrent()
    const failed = () => {
      if (!current()) return
      generation++
      close(); onStatus('fallback')
      schedule(Math.min(30000, 1000 * 2 ** Math.min(failures++, 5)))
    }
    try {
      const config = await api.config(abort.signal)
      if (!current()) return
      if (!config.realtimeEnabled) { onStatus('disabled'); schedule(60000); return }
      const value = await api.streamTicket(abort.signal)
      if (!current()) return
      if (typeof value?.ticket !== 'string' || !/^[a-f0-9-]{36}$/.test(value.ticket)) throw new Error('消息连接票据无效')
      source = new Source(`/api/messages/stream?ticket=${encodeURIComponent(value.ticket)}`)
      source.addEventListener('ready', () => {
        if (!current()) return
        clearTimeout(readyTimer); failures = 0; onStatus('connected'); onChange()
      })
      source.addEventListener('changed', () => { if (current()) onChange() })
      source.onerror = failed
      readyTimer = setTimeout(failed, 20000)
    } catch { failed() }
  }
  const restart = () => { generation++; close(); failures = 0; void connect() }
  const offline = () => { generation++; close(); onStatus('fallback') }
  const storage = event => { if (['token', 'refreshToken', 'user', null].includes(event.key)) restart() }
  window.addEventListener('online', restart)
  window.addEventListener('offline', offline)
  window.addEventListener('storage', storage)
  window.addEventListener('gutdb-auth-token-updated', restart)
  void connect()
  return { stop() {
    stopped = true; generation++; close()
    window.removeEventListener('online', restart); window.removeEventListener('offline', offline)
    window.removeEventListener('storage', storage); window.removeEventListener('gutdb-auth-token-updated', restart)
  } }
}
